import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { importProvidersFrom, LOCALE_ID } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { provideToastr } from 'ngx-toastr';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { AppServices } from './app/servicelayer/app-services';

// Register US English locale
registerLocaleData(localeEn, 'en-US');

bootstrapApplication(AppComponent, {
    providers: [
        provideRouter(routes),
        provideHttpClient(),
        provideAnimations(),
        provideToastr({
            timeOut: 3000,
            positionClass: 'toast-top-right',
            preventDuplicates: true,
            progressBar: true,
            closeButton: true,
            newestOnTop: true
        }),
        importProvidersFrom(ReactiveFormsModule, FormsModule),
        { provide: LOCALE_ID, useValue: 'en-US' }, // Set US locale for consistent date formatting
        AppServices
    ]
}).catch(err => console.error(err));